<template>
    <div class="col-12">
        <h2 class="h1 text-uppercase">{{ $t('envio.envio_titulo') }}</h2>
        <template v-if="! envio_domicilio">
            <div class="subtitle h3 light mb-4">{{$t('envio.desea' , {precio: lista_abonados.precio_envio_a_domicilio})}}</div>
            <div class="d-flex">
                <button class="btn btn-primary mr-2" id="enviar" name="enviar" @click="quererEnvio" :disabled="desactivar">{{ $t("envio.si") }}</button>
                <button class="btn btn-primary mr-2" id="no_enviar" name="no_enviar" @click="continuarSinEnvio" :disabled="desactivar">{{ $t("envio.no") }}</button>
                <button class="btn btn-primary" id="no_enviar" name="no_enviar" @click="atras" :disabled="desactivar">{{ $t("envio.atras") }}</button>
            </div>
        </template>        
        <div v-else>
            <div v-if="datos_compradores.length == 1 && direccion_envio_abono == ''">
                <div class="subtitle h3 light mb-3">{{$t('envio.quieres')}}</div>
                <div class="d-flex">
                    <button class="btn btn-primary mr-2" id="misma_direccion" name="misma_direccion" @click="envioMismoDomicilio" :disabled="desactivar">{{ $t("envio.si") }}</button>
                    <button class="btn btn-primary" id="distinta_direccion" name="distinta_direccion" @click="direccion_envio_abono = 'distinta_direccion'" :disabled="desactivar">{{ $t("envio.no") }}</button>
                </div>
            </div>
            <ValidationObserver tag="form" ref="observer" v-if="direccion_envio_abono == 'distinta_direccion' || datos_compradores.length > 1" @submit.prevent="submit()">
                <h4>{{ $t("envio.introduce_direccion") }}</h4>
                <div class="lightgray-content p-2 mb-4 mt-2">
                    <div class="col-12 p-2">
                        <FormInput :label="$t('formularios.nombre')" name="nombre_envio" rules="required" v-model="datos_envio.nombre" :disabled="desactivar"/>
                        <FormInput :label="$t('formularios.apellidos')" name="apellidos_envio" rules="required" v-model="datos_envio.apellidos" :disabled="desactivar"/>
                        <FormInput :label="$t('formularios.domicilio')" name="domicilio_envio" rules="required" v-model="datos_envio.domicilio"  :disabled="desactivar"/>
                        <Provincias class="form-group" :pais="68" v-on:selected="opt => { provincia = opt; datos_envio.provincia = opt.nombre; }" :disabled="desactivar"/>
                        <Locations class="form-group" :provincia="provincia" v-on:selected="opt => { datos_envio.localidad = opt.nombre; }" :disabled="desactivar"/>
                        <FormInput :label="$t('formularios.cp')" name="cp_envio" rules="required" v-model="datos_envio.cp"  :disabled="desactivar"/>
                        <FormInput :label="$t('formularios.telefono')" name="telefono_envio" rules="required" v-model="datos_envio.telefono" :disabled="desactivar"/>
                        <FormInput :label="$t('formularios.observaciones')" name="observaciones_envio" rules="" v-model="datos_envio.observaciones" :disabled="desactivar"/>
                        <div class="mt-4 form-button-responsive">
                            <button id="compra-responsive" type="submit" class="button effect-button large-button" :disabled="desactivar"><span>{{ $t('nuevo_abono.continuar_compra') }}</span></button>
                            <button id="atras-responsive" class="button effect-button large-button ml-2" @click="envio_domicilio = false" :disabled="desactivar"><span>{{ $t("envio.atras") }}</span></button>
                        </div>
                    </div>
                </div>
            </ValidationObserver>
        </div>
    </div>
</template>

<script>
    import Provincias from "../../../common/forms/Provincias";
    import Locations from "../../../common/forms/Locations";
    export default {
        props: {
            datos_compradores: {
                required: true,
                type: Array
            },
            desactivar: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                envio_domicilio: false,
                direccion_envio_abono: '',
                datos_envio: {
                    'nombre': '',
                    'apellidos': '',
                    'domicilio': '',
                    'cp': '',
                    'telefono': '',
                    'observaciones': '',
                    'gastos_envio': '',
                    'provincia': '',
                    'localidad': ''
                },
                provincia : null,
            }
        },
        created() {
            this.datos_envio.gastos_envio = this.lista_abonados.precio_envio_a_domicilio;
        },
        computed: {
            lista_abonados() {
                return this.$store.getters.getListaAbonados;
            }
        },
        methods: {
            quererEnvio() {
                this.envio_domicilio = 'enviar';
            },
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    this.$emit('envioSolicitado', this.datos_envio);
                }
            },
            continuarSinEnvio() {
                this.$emit('continuarSinEnvio');
            },
            envioMismoDomicilio() {
                this.$emit('envioSolicitado', this.datos_envio);
            },
            atras() {
                this.$emit('atras');
            },
        },
        components: {
            Provincias, Locations
        }
    }
</script>

<style scoped>
    @media (max-width: 768px) {
        .button.large-button {
            min-width: 40vw !important;
            margin-right: 4%;
        }
    }
</style>